import { FC } from "react";
import { ErrorMessage } from "../../components/ErrorMessage";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { useHostedTools } from "./HostedTools.hook";
import "./style.css";

const formatModified = (value: string | null) => {
  if (!value) {
    return "";
  }

  return new Date(value).toLocaleString();
};

export const HostedTools: FC = () => {
  const { groups, query, setQuery, isLoading, error, total, visible } =
    useHostedTools();

  if (isLoading) {
    return <LoadingIndicator isLoading />;
  }

  return (
    <div className="hosted-tools">
      <ErrorMessage error={error} />
      <label className="hosted-tools-filter">
        <span>
          Filter ({visible} of {total})
        </span>
        <input
          value={query}
          placeholder="Country, path or tool"
          onChange={(event) => setQuery(event.target.value)}
        />
      </label>
      {groups.length === 0 && <p>No pages match this filter.</p>}
      {groups.map((section) => (
        <section key={section.group}>
          <h2 className="table-header">
            {section.group} ({section.tools.length})
          </h2>
          <table className="hosted-tools-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Path</th>
                <th>Updated</th>
                <th>Page</th>
              </tr>
            </thead>
            <tbody>
              {section.tools.map((tool, index) => (
                <tr className="hosted-tools-row" key={tool.path}>
                  <td>{index + 1}</td>
                  <td>{tool.name}</td>
                  <td className="hosted-tools-path">{tool.path}</td>
                  <td>{formatModified(tool.lastModified)}</td>
                  <td>
                    <a
                      className="hosted-tools-link"
                      href={tool.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Open
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
};
